import moment, { Moment } from 'moment';
import React from 'react';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';

export interface PatientsFilledQuestionnairesFilterValues {
	patientId: string;
	dateFrom?: Moment | string;
	dateTo?: Moment | string;
	excludeQuestionnaireCodes: string[];
	module?: QuestionnaireModule;
}

interface PatientsFilledQuestionnairesFilterProps {
	onFilter: (values: PatientsFilledQuestionnairesFilterValues) => void;
	module?: QuestionnaireModule;
	patientId: string;
}

const PatientsFilledQuestionnairesFilter: React.FC<
	PatientsFilledQuestionnairesFilterProps
> = ({ onFilter, patientId, module }) => {
	const onFilterData = (values: any) => {
		const filter: PatientsFilledQuestionnairesFilterValues = {
			patientId,
			dateFrom: values?.dateFrom
				? moment(values.dateFrom).format('YYYY-MM-DD')
				: undefined,
			dateTo: values?.dateTo
				? moment(values.dateTo).format('YYYY-MM-DD')
				: undefined,
			excludeQuestionnaireCodes: [
				'meddibaby_entry_questionnaire',
				'meddibaby_regular_inspection',
				'meddibaby_end_questionnaire',
			],
			module: module,
		};

		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={(values: any) => onFilterData(values)}
			storageKey={GRID_FILTER_KEYS.PATIENTS_FILLED_QUESTIONNAIRES_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={170}
				customLabel='base.shared.from'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_TO}
				width={170}
				customLabel='base.shared.to'
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default PatientsFilledQuestionnairesFilter;
